export const evmTokenMessengerV2 = "0x28b5a0e9C621a5BadaA536219b3a228C8168cf5d";
export const evmMessageTransmitterV2 =
    "0x81D40F21F12A8F0E3252Bccb954D722d4c464B64";

export const solanaTokenMessengerMinterV2 =
    "CCTPV2vPZJS2u2BBsUoscuikbYjnpFmbFsvVuJdgUMQe";
export const solanaMessageTransmitterV2 =
    "CCTPV2Sm4AdWt5296sk4P66VBZ7bEhcARwFaaS9YPbeC";
